import MenuItem from '@mui/material/MenuItem'
import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {ageList, setFilter, useAllSearchFilters} from 'entities/searchPeople'
import {Select} from 'shared/ui/select'
import styles from './styles.module.scss'

type SPAgeFromToProps = {
  width?: string
  style?: object
  className?: string
}

export const SPAgeFromTo: FC<SPAgeFromToProps> = ({width, style, className}) => {
  const dispatch = useDispatch()
  const {ageFrom, ageTo} = useAllSearchFilters()

  return (
    <div className={`${styles.fromToAge} ${className}`}>
      <Select
        value={ageFrom}
        onChange={(event) => dispatch(setFilter({value: event.target.value, key: 'ageFrom'}))}
        width={width}
        style={style}
        displayEmpty
        placeholder='From'
        sizePopup='xs'
      >
        {
          ageList
            .filter((age) => ageTo ? ageTo >= age : true)
            .map((age) => <MenuItem key={age} value={age}>{age}</MenuItem>)
        }
      </Select>
      <div className={styles.divider}><span></span></div>
      <Select
        value={ageTo}
        onChange={(event) => dispatch(setFilter({value: event.target.value, key: 'ageTo'}))}
        width={width}
        style={style}
        displayEmpty
        placeholder='To'
        sizePopup='xs'
      >
        {
          ageList
            .filter((age) => ageFrom ? ageFrom <= age : true)
            .map((age) => <MenuItem key={age} value={age}>{age}</MenuItem>)
        }
      </Select>
    </div>
  )
}